<ng-container *ngIf="_episodeName$ | async as episodeName" [ngSwitch]="selectedTemplate">
  <oval-content-LM1 episodeName="{{episodeName}}" *ngSwitchCase="1"></oval-content-LM1>
  <oval-content-LM2 episodeName="{{episodeName}}" *ngSwitchCase="2"></oval-content-LM2>
  <oval-content-LM3 episodeName="{{episodeName}}" *ngSwitchCase="3"></oval-content-LM3>
  <oval-content-LM4 episodeName="{{episodeName}}" *ngSwitchCase="4"></oval-content-LM4>
  <oval-content-LM5 episodeName="{{episodeName}}" *ngSwitchCase="5"></oval-content-LM5>
  <oval-content-LM6 episodeName="{{episodeName}}" *ngSwitchCase="6"></oval-content-LM6>
  <oval-content-Default episodeName="{{episodeName}}" *ngSwitchCase="7"></oval-content-Default>
</ng-container>